import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    closable: { type: Boolean, default: true },
    closeOnSubmit: { type: Boolean, default: true },
  };

  connect() {
    document.body.classList.add("overflow-hidden");

    document.addEventListener("turbo:submit-end", this.handleSubmit);
    document.addEventListener("keyup", this.handleKeyup);
    document.addEventListener("turbo:before-cache", this.close);
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden");

    document.removeEventListener("turbo:submit-end", this.handleSubmit);
    document.removeEventListener("keyup", this.handleKeyup);
    document.removeEventListener("turbo:before-cache", this.close);
  }

  close = (event) => {
    event?.preventDefault();

    if (!this.closableValue) return;

    if (this.element.parentNode) {
      this.element.parentNode.src = undefined;
    }

    this.element.remove();
  };

  closeFromMask(event) {
    if (
      event.target.classList.contains("fixed") &&
      !window.getSelection().toString().length
    ) {
      event.preventDefault();
      event.stopPropagation();
      this.close(event);
    }
  }

  handleKeyup = (event) => {
    if (event.code === "Escape") {
      this.close();
    }
  };

  handleSubmit = (event) => {
    if (event.detail.success && this.closeOnSubmitValue) {
      this.close();
    }
  };
}
